import React, {useState} from 'react'
import {connect, useSelector} from "react-redux";


// components
import AssignScheduleTime from "./AssignScheduleTime";
import CreateRecurringScheduleLabel from "./CreateRecurringScheduleLabel";
import {ButtonCancel, ButtonSave, CustomButton} from "../buttons/buttonsActions";

// labels
import { CONTINUE } from "../i18n/i18n";

// actions
import {save} from "../../redux/actions/hotel/afiPickupScheduleActions";
import {getStateByPath} from "../../redux/selectors";


/**
 * Componente para gestionar la captura de los horarios recurrentes
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const RecurringSchedule = props => {
    const componentState = useSelector(state => getStateByPath(state, props?.path));
    const { domainObject:afi, app, udn } = componentState?.data;
    const fbDataBaseId = app?.fbDataBase?.id
    const {onClose} = props

    const [time, setTime] = useState() // hora que se capturará
    const [minutes, setMinutes] = useState() // minuto seleccionado
    const [baseLabel, setBaseLabel] = useState('') // label base
    const [label, setLabel] = useState('') // label base
    const [view, setView] = useState('LABEL') // vista que se mostrará
    const [saving, setSaving] = useState(false) // vista que se mostrará


    /**
     * Confirmar el guardado de los datos seleccionados
     */
    const onConfirmSchedule = () => {
        const request = {
            fbDataBase: { id: fbDataBaseId },
            item: {
                udnFrom: { id: udn?.id},
                afi: { id: afi?.id },
                recurring: true,
                recurringSchedule:{
                    time,
                    minutes,
                    baseLabel,
                    langs: [{
                            label,
                    }]
                },
            }
        }

        setSaving(true)
        props.save(request, changeLoading)
    }

    const changeLoading = (value) => {
        setSaving(value)
        onClose()
    }


    return <>
            {
                view === "LABEL"
                ? <CreateRecurringScheduleLabel
                        onLabelChange={ setBaseLabel }
                />
                : <AssignScheduleTime
                        originalLabel={ baseLabel }
                        onTimeChange={ setTime }
                        onMinutesChange={ setMinutes }
                        onLabelChange={ setLabel }
                />
            }
        &nbsp;
        {
            view === "LABEL"
            ? <CustomButton title={ CONTINUE } onClick={ () => setView('HOURS')} disabled={ baseLabel==''}/>
            : <ButtonSave onClick={onConfirmSchedule} disabled={minutes <= 0 || saving} loading={saving}/>
        }
    </>
}

const mapStateToProps = state => ({});
const mapActionsToProps = ({ save })

export default connect(mapStateToProps, mapActionsToProps)(RecurringSchedule)